/* ============================================================
   YL-HEADER — Kanonischer Atomic-Header (site-weit, self-contained).
   Ein Component für Haupt- + alle Unterseiten. Injiziert eigenes CSS
   (unabhängig vom Seiten-CSS-Stack) → überall identisches Aussehen.
   Mount: ersetzt vorhandenen <header class="nav"> oder füllt #yl-header.
   Links absolut auf die Hauptseiten-Sektionen (funktioniert auch on-page).
   Warenkorb: öffnet Drawer wenn vorhanden, sonst Link auf /#kaufen.
   Sofia Pro (lädt sofia.css nach, falls nicht vorhanden).
   ============================================================ */
(function () {
  "use strict";
  var ORANGE = "#E85817";

  /* sofia.css sicherstellen (self-hosted @font-face) */
  if (false) {
    var lf = document.createElement("link");
    lf.rel = "stylesheet"; lf.href = "/260708/css/sofia.css?v=260707n";
    document.head.appendChild(lf);
  }

  var SOFIA = '"sofia-pro","Sofia Pro","Roobert",-apple-system,system-ui,sans-serif';
  var LOGO = '<svg class="ylh__logo" width="220" height="49" viewBox="0 0 220 49" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="yuvenlife">'
    + '<path d="M219.671 26.262H198.517C199.294 30.0375 202.348 32.8136 205.957 32.8136C208.677 32.8136 211.065 31.259 212.397 28.8715H219.116C217.339 34.7569 212.12 39.0321 205.957 39.0321C198.295 39.0321 192.132 32.425 192.132 24.3187C192.132 16.2125 198.295 9.60535 205.957 9.60535C212.12 9.60535 217.339 13.8806 219.116 19.7659C219.56 21.2095 219.782 22.7086 219.782 24.3187C219.782 24.985 219.782 25.5957 219.671 26.262ZM199.516 19.7659H212.397C211.065 17.3784 208.677 15.8238 205.957 15.8238C203.236 15.8238 200.849 17.3784 199.516 19.7659Z" fill="#ABB3BC"/>'
    + '<path d="M190.439 5.71874C187.219 5.82979 185.553 7.38441 185.553 10.3271V11.4375H190.439V17.8781H185.553V38.8655H179.113L179.168 17.8781H177.336V11.4375H179.168V10.1605C179.168 3.55338 182.999 0.055481 190.217 0.055481H190.439V5.71874Z" fill="#ABB3BC"/>'
    + '<path d="M170.386 7.55101C168.332 7.55101 166.666 5.82983 166.666 3.77551C166.666 1.72119 168.332 0 170.386 0C172.441 0 174.162 1.72119 174.162 3.77551C174.162 5.82983 172.441 7.55101 170.386 7.55101ZM173.551 38.921H167.166V9.16116H173.551V38.921Z" fill="#ABB3BC"/>'
    + '<path d="M162.436 38.921H156.051V0H162.436V38.921Z" fill="#ABB3BC"/>'
    + '<path d="M137.983 9.16113C145.645 9.16113 151.975 15.8238 151.975 23.9855V38.8655H145.479V23.9855C145.479 19.3772 142.092 15.6572 137.983 15.6572C133.819 15.6572 130.432 19.3772 130.432 23.9855V38.921H123.992V24.0411C123.992 15.8238 130.266 9.16113 137.983 9.16113Z" fill="black"/>'
    + '<path d="M121.097 26.262H99.9434C100.721 30.0375 103.774 32.8136 107.383 32.8136C110.104 32.8136 112.491 31.259 113.824 28.8715H120.542C118.765 34.7569 113.546 39.0321 107.383 39.0321C99.7213 39.0321 93.5583 32.425 93.5583 24.3187C93.5583 16.2125 99.7213 9.60535 107.383 9.60535C113.546 9.60535 118.765 13.8806 120.542 19.7659C120.986 21.2095 121.208 22.7086 121.208 24.3187C121.208 24.985 121.208 25.5957 121.097 26.262ZM100.943 19.7659H113.824C112.491 17.3784 110.104 15.8238 107.383 15.8238C104.663 15.8238 102.275 17.3784 100.943 19.7659Z" fill="black"/>'
    + '<path d="M87.1854 9.16113H94.2367L81.6332 38.8655H74.6929L61.8118 9.16113H68.8076L78.1353 30.5927L87.1854 9.16113Z" fill="black"/>'
    + '<path d="M53.736 9.21667H60.2321V24.0966C60.2321 32.2584 53.9025 38.921 46.2405 38.921C38.5229 38.921 32.2489 32.2584 32.2489 24.0966V9.2722H38.6895V24.0966C38.6895 28.705 42.0763 32.4805 46.2405 32.4805C50.3491 32.4805 53.736 28.705 53.736 24.0966V9.21667Z" fill="black"/>'
    + '<path d="M23.2638 9.16113H30.4817L17.656 48.4153H10.4937L16.4346 30.204H9.21668L0 9.16113H7.16236L16.4346 30.204L23.2638 9.16113Z" fill="black"/>'
    + '</svg>';

  var css = ""
    + ".ylh{position:fixed;top:0;left:0;right:0;z-index:80;background:color-mix(in srgb,#fff 58%,transparent);-webkit-backdrop-filter:saturate(160%) blur(16px);backdrop-filter:saturate(160%) blur(16px);border-bottom:1px solid rgba(0,0,0,.06);font-family:" + SOFIA + ";transition:transform .35s cubic-bezier(.4,0,.2,1),background .3s}"
    + ".ylh--hidden{transform:translateY(-100%)}"
    + ".ylh--solid{background:color-mix(in srgb,#fff 82%,transparent)}"
    + ".ylh__bar{display:flex;align-items:center;gap:clamp(1rem,2vw,1.5rem);max-width:1680px;margin-inline:auto;padding:clamp(1rem,1.5vw,1.7rem) clamp(1.25rem,4vw,2.75rem)}"
    + ".ylh__brand{display:inline-flex;align-items:center;line-height:0}"
    + ".ylh__logo{width:clamp(112px,9.5vw,150px);height:auto;display:block}"
    + ".ylh__links{display:flex;gap:clamp(1.1rem,2.4vw,2.8rem);align-items:center;margin-left:auto}"
    + ".ylh__links a,.ylh__cart{color:#707070;font-weight:400;letter-spacing:.01em;font-size:clamp(.95rem,1.15vw,22px);text-decoration:none;background:none;border:0;cursor:pointer;font-family:inherit;padding:0;transition:color .3s ease-out}"
    + ".ylh__links a:hover,.ylh__cart:hover,.ylh__links a[aria-current=page]{color:#1A1A1A}"
    + ".ylh__cart{position:relative}"
    + ".ylh__cart [data-cart-count]{position:absolute;top:-9px;right:-9px;min-width:20px;height:20px;padding:0 6px;background:" + ORANGE + ";color:#fff;border-radius:999px;font-size:12px;font-weight:600;display:inline-flex;align-items:center;justify-content:center;line-height:1}"
    + ".ylh__cart [data-cart-count][hidden]{display:none}"
    + "@keyframes ylh-pop{0%{transform:scale(1)}45%{transform:scale(1.4)}100%{transform:scale(1)}}"
    + ".ylh__cart [data-cart-count].ylh-bump{animation:ylh-pop .35s ease}"
    + ".ylh__toggle{display:none;margin-left:auto;align-items:center;justify-content:center;line-height:1;background:none;border:1px solid #ccc;border-radius:999px;min-height:46px;padding:.7em 1.4em;font-family:inherit;font-size:1rem;font-weight:500;color:#1A1A1A;cursor:pointer}"
    + "@media(max-width:820px){.ylh__links{display:none;position:absolute;top:100%;left:0;right:0;flex-direction:column;align-items:stretch;background:color-mix(in srgb,#fff 70%,transparent);-webkit-backdrop-filter:saturate(160%) blur(18px);backdrop-filter:saturate(160%) blur(18px);border-bottom:1px solid rgba(0,0,0,.06);padding:clamp(1rem,4vw,1.6rem);gap:.25rem}.ylh[data-open=true] .ylh__links{display:flex}.ylh__toggle{display:inline-flex}.ylh__links a,.ylh__cart{min-height:60px;display:flex;align-items:center;font-size:1.35rem;font-weight:500;color:#1A1A1A;padding-inline:.5rem;border-radius:14px}.ylh__links a:active,.ylh__cart:active{background:rgba(0,0,0,.05)}}"
    + "@media(prefers-reduced-motion:reduce){.ylh__links a,.ylh__cart{transition:none}}";

  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  /* Homepage-Basis: aktuelle Live-Version. NACH Shopify-Umzug hier absolute Host-URL setzen (z.B. https://yuvenlife.com/). */
  var HOME = "/";
  var hasCart = !!document.querySelector(".cart-drawer");
  var cartHtml = hasCart
    ? '<button class="ylh__cart" type="button" data-cart-toggle aria-haspopup="dialog">Warenkorb <span class="mono" data-cart-count>0</span></button>'
    : '<a class="ylh__cart" href="' + HOME + '#kaufen">Warenkorb</a>';

  var header = document.createElement("header");
  header.className = "ylh"; header.id = "nav";
  header.innerHTML =
    '<div class="ylh__bar">'
    + '<a class="ylh__brand" href="' + HOME + '" aria-label="yuvenlife, Startseite">' + LOGO + '</a>'
    + '<button class="ylh__toggle" type="button" aria-expanded="false" aria-controls="nav" aria-label="Menü"><svg class="ylh__burger" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true"><path d="M4 8h20M4 14h20M4 20h20" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>'
    + '<nav class="ylh__links" aria-label="Hauptnavigation">'
    + '<a href="' + HOME + 'products/yuvenlife-functional-nutrition-oel-500ml?view=yuvenlife-system#kaufen">Produkte</a>'
    + '<a href="/pages/pflichtangaben">Inhaltsstoffe</a>'
    + '<a href="/pages/wissen">Wissen</a>'
    + '<a href="' + HOME + 'pages/faqs">FAQ</a>'
    + cartHtml
    + '</nav>'
    + '</div>';

  /* Mount: vorhandenen header.nav ODER #yl-header ersetzen, sonst oben einfügen */
  function mount() {
    var old = document.querySelector("header.nav") || document.getElementById("yl-header");
    if (old && old.parentNode) old.parentNode.replaceChild(header, old);
    else document.body.insertBefore(header, document.body.firstChild);

    var tog = header.querySelector(".ylh__toggle");
    tog.addEventListener("click", function () {
      var open = header.getAttribute("data-open") === "true";
      header.setAttribute("data-open", open ? "false" : "true");
      tog.setAttribute("aria-expanded", open ? "false" : "true");
    });
    /* Klick auf einen Menüpunkt (Link oder Warenkorb) → Menü schließen */
    header.querySelectorAll(".ylh__links a, .ylh__cart").forEach(function (el) {
      el.addEventListener("click", function () {
        header.setAttribute("data-open", "false");
        tog.setAttribute("aria-expanded", "false");
      });
    });
    /* Auf der Homepage selbst (/260708/): Links zu On-Page-Ankern (kein Reload auf falsche Wurzel) */
    if ((location.pathname === "/" || location.pathname === "")) {
      header.querySelectorAll('.ylh__links a[href^="' + HOME + '#"]').forEach(function (a) {
        a.setAttribute("href", a.getAttribute("href").slice(HOME.length)); // /260708/#kaufen → #kaufen
      });
    }
    /* Cart-Bubble Pop bei Zähler-Änderung (Warenkorb vorhanden) */
    var cnt = header.querySelector(".ylh__cart [data-cart-count]");
    if (cnt && "MutationObserver" in window) {
      new MutationObserver(function () {
        cnt.classList.remove("ylh-bump"); void cnt.offsetWidth; cnt.classList.add("ylh-bump");
      }).observe(cnt, { childList: true, characterData: true, subtree: true });
    }

    /* Header ist fixed + frosted (liegt auf dem Hero). Auf Nicht-Hero-Seiten
       Body-Padding, damit der Content nicht darunter verschwindet. */
    var onHome = location.pathname === "/" || location.pathname === "" || (location.pathname === "/" || location.pathname === "");
    function applyPad() {
      var h = header.offsetHeight;
      document.body.style.setProperty("--ylh-h", h + "px");
      if (!onHome) document.body.style.paddingTop = h + "px";
    }
    applyPad();
    addEventListener("resize", applyPad);

    /* Headroom: runter scrollen → Header ausblenden, hoch scrollen → reinfahren.
       Am Seitenanfang immer sichtbar + transparenter (frosted auf Hero). */
    var lastY = window.pageYOffset || 0, ticking = false;
    function onScroll() {
      var y = window.pageYOffset || 0;
      if (y <= 4) { header.classList.remove("ylh--hidden"); header.classList.remove("ylh--solid"); }
      else {
        if (y > lastY && y > header.offsetHeight) header.classList.add("ylh--hidden");  // runter → weg
        else header.classList.remove("ylh--hidden");                                    // hoch → rein
        header.classList.add("ylh--solid");                                             // gescrollt → etwas fester
      }
      lastY = y; ticking = false;
    }
    addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }
  if (document.body) mount();
  else document.addEventListener("DOMContentLoaded", mount);
})();


